'use client'

import { createContext, useContext, useMemo, useState } from 'react'

import type { SizeGuideUnit } from '../../types'

export interface UnitsContextType {
	selectedUnit: SizeGuideUnit
	selectUnit: (newSelectedUnit: SizeGuideUnit) => void
}

interface UnitsProviderProps {
	readonly children: React.ReactNode
	readonly unit: SizeGuideUnit
}

export const UnitsContext = createContext<UnitsContextType | undefined>(
	undefined
)

export function UnitsProvider({
	children,
	unit,
}: UnitsProviderProps): React.ReactNode {
	const [selectedUnit, setSelectedUnit] = useState(unit)

	const selectUnit = (newUnit: SizeGuideUnit): void => {
		setSelectedUnit(newUnit)
	}

	const value = useMemo(
		() => ({
			selectedUnit,
			selectUnit,
		}),
		[selectedUnit]
	)

	return <UnitsContext.Provider value={value}>{children}</UnitsContext.Provider>
}

/** @throws {Error} If useUnit is used without UnitsProvider */
export const useUnit = (): UnitsContextType => {
	const context = useContext(UnitsContext)
	if (!context) {
		throw new Error('useUnit must be used within a UnitsProvider')
	}
	return context
}
